import {getTitle} from '../routes';
import {getMenus} from '../services/auth';

export default {
    computed:{
        routeTitle(){
            const {name} = this.$route;
            return getTitle(name, getMenus());
        }
    }
}